// extracted by mini-css-extract-plugin
module.exports = {"CarrouselItem":"carrouselItem_CarrouselItem__2odbg"};